"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (tick) {
    return [+tick.epoch * 1000, +tick.quote];
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/tickToData.js
// module id = 121
// module chunks = 0